import React from 'react';
import { endpoints } from 'endpoints.config';
import { downloadFile } from 'helpers/downloadFile';
import { openFile } from 'helpers/openFile';

type Props = {
  closeMenu?: () => void;
  rowId?: number;
  openCloseState: { open: boolean; id: number | null };
  name: string;
};

export const InvoiceDropdownOptions: React.FC<Props> = ({
  closeMenu,
  rowId,
  openCloseState,
  name,
}) => {
  const downloadInvoice = () => {
    if (!rowId) return;
    downloadFile(
      endpoints.invoices.downloadInvoice + '?subscriptionHistoriesID=' + rowId,
      name,
    );
  };
  return (
    <React.Fragment>
      {openCloseState.open && openCloseState.id === rowId && (
        <div className="RowOptionsMenuContainer">
          {rowId && closeMenu && (
            <div className="ItemsContainer">
              {/* View Invoice */}
              <div
                className="Item"
                onClick={() => {
                  closeMenu();
                  openFile(rowId);
                }}
              >
                <span>View Invoice</span>
              </div>
              {/* Download Invoice */}
              <div
                className="Item"
                onClick={() => {
                  closeMenu();
                  downloadInvoice();
                }}
              >
                <span>Download Invoice</span>
              </div>
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};
